import axios from "axios";
import { COPY_CHECK_URL } from "../constant";
const { decorate, observable, action } = require("mobx");
const instance = axios.create();
instance.defaults.timeout = 30000; //타임 아웃 30초
class Init {
  cols = [];
  rows = [];
  status = "idle";
  blocking = false;
  url = "";
  loc = "";
  jobCount = 1;
  titleIndex;
  isbn13Index;
  isbn10Index;
  ebookisbnIndex;

  async setCols(cols) {
    this.cols = cols;
  }

  async setRows(rows) {
    this.status = "idle";
    this.jobCount = 1;
    if (Array.isArray(rows) && rows.length > 0) {
      rows.map((row, index) => {
        if (index == 0) {
          for (const [key, value] of Object.entries(row)) {
            row[key] = value.replace("\n", "");
          }

          row.splice(1, 0, "단행본", "전자책", "비고");
          this.titleIndex = row.indexOf("도서명");
          this.isbn13Index = row.indexOf("ISBN");
          this.isbn10Index = row.indexOf("ISBN 10");
          this.ebookisbnIndex = row.indexOf("EBOOKISBN");
        } else {
          row.splice(1, 0, "checking", "checking", "checking");
        }
      });
      this.rows = rows;
    }
  }

  async startJob(url, loc) {
    this.url = url;
    this.loc = loc;
    this.blocking = true;
    this.jobCount = 1;
    this.status = "idle";
    // if (this.rows.length > 0) {
    //   this.rows.map((e, index) => {
    //     console.log(index);
    //     if (index != 0) {
    //       const searchTitle = e[this.titleIndex];
    //       const isbn13 = e[this.isbn13Index];
    //       const isbn10 = e[this.isbn10Index];
    //       const ebookisbn = e[this.ebookisbnIndex];
    //      this.copyCheck(
    //         this.url,
    //         this.loc,
    //         searchTitle,
    //         isbn13,
    //         isbn10,
    //         ebookisbn,
    //         index
    //       );
    //     }
    //   });
    // }

    for (let i = 0; i < this.rows.length; i++) {
      if (i !== 0) {
        const e = this.rows[i];
        const searchTitle = e[this.titleIndex];
        const isbn13 = e[this.isbn13Index];
        const isbn10 = e[this.isbn10Index];
        const ebookisbn = e[this.ebookisbnIndex];
        await this.copyCheck(
          this.url,
          this.loc,
          searchTitle,
          isbn13,
          isbn10,
          ebookisbn,
          i
        );
      }
    }
  }

  async copyCheck(url, loc, searchTitle, isbn13, isbn10, ebookisbn, index) {
    try {
      const response = await instance.post(COPY_CHECK_URL, {
        url: url,
        loc: loc,
        title: searchTitle,
        isbn13: isbn13,
        isbn10: isbn10,
        ebookisbn: ebookisbn
      });
      const isBook = response.data.isBook;
      const isEbook = response.data.isEbook;
      const title = response.data.title;
      //const bigo = response.data.bigo;
      //const jobCouunt = response.data.jobCount;
      const row = this.rows[index];
      row[1] = isBook == "Y" ? "1" : "";
      row[2] = isEbook == "Y" ? "1" : "";
      row[3] = `${index},${title},${isBook},${isEbook}`;
      this.jobCount++;
      console.log(title, isBook, isEbook);
      if (this.jobCount == this.rows.length) {
        this.blocking = false;
        this.status = "end";
      }
    } catch (error) {
      console.error(error.name, error.message);
      const row = this.rows[index];
      row[1] = "Error";
      row[2] = "Error";
      row[3] = "Error";
      this.jobCount++;
      if (this.jobCount == this.rows.length) {
        this.blocking = false;
        this.status = "end";
      }
    }
  }
}

decorate(Init, {
  cols: observable,
  rows: observable,
  blocking: observable,
  jobCount: observable,
  status: observable,
  url: observable,
  loc: observable,
  startJob: action,
  setCols: action,
  setRows: action
});

const Copy = new Init();
export default Copy;
